import { ActionFactoryParams } from '../../../../utilsDeprecated/ControlledComponent/ControlledComponent.types';
import { CalendarStateDeprecated } from '../../controller';
import { CalendarContext } from '../../../../utilsDeprecated/context/contextFactory';
import { CalendarErrors } from '../../../../types/types';

export type AddError = (errorType: CalendarErrors) => void;

export function createAddErrorAction({
  getControllerState,
}: ActionFactoryParams<CalendarStateDeprecated, CalendarContext>): AddError {
  return (errorType: CalendarErrors) => {
    const [state, setState] = getControllerState();

    const { calendarErrors: prevCalendarErrors } = state;
    const calendarErrors = prevCalendarErrors;

    const isErrorAlreadyExists = prevCalendarErrors.includes(errorType);
    if (!isErrorAlreadyExists) {
      setState({
        calendarErrors: [...calendarErrors, errorType],
      });
    }
  };
}
